// extracted by mini-css-extract-plugin
export default {"container":"_404_container__A208i","status":"_404_status__vzy2b","message":"_404_message__DEdmJ"};